import { useMutation as l } from "@apollo/client";
import { accountSchema as c } from "../../deserialize/yup/account.js";
import u from "../../graphql/client/loginClient.js";
import { deserializeData as p } from "../../graphql/deserialize/index.js";
import f from "../../graphql/mutation/loginByEmail.js";
import { useState as d, useCallback as g } from "react";
const E = () => {
  const [t, { loading: o }] = l(f, {
    client: u
  }), [e, n] = d(null);
  return {
    mutate: g(
      async (r) => {
        const { email: i, password: s } = r, m = await t({
          variables: {
            input: {
              email: i,
              password: s
            }
          }
        }), a = p(m, c);
        return n(a), a;
      },
      [t]
    ),
    data: e,
    loading: o
  };
};
export {
  E as default
};
//# sourceMappingURL=useLoginByEmail.js.map
